module.exports = __webpack_public_path__ + "media/images/background-b5833a08d6d9bfaecf47c8fa746bbbf8.jpg";